export default {
  affectedUserData: ({ affectedUserData }) => affectedUserData || null,
  payload: ({ payload }) => payload || null,
}
